module.exports = [{"key":"1","name":"类型","data":[{"key":"1","name":"主题"},{"key":"2","name":"非标应用"},{"key":"3","name":"标准产品通用"},{"key":"4","name":"定制开发"},{"key":"5","name":"..."}]},{"key":"2","name":"行业","data":[{"key":"1","name":"市政府行业"},{"key":"2","name":"照明行业"},{"key":"3","name":"期货行业"},{"key":"4","name":"保险行业"},{"key":"5","name":"..."}]},{"key":"3","name":"终端","data":[{"key":"1","name":"PC"},{"key":"2","name":"MOBILE"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/mocks/screen_develop.json
// module id = 529
// module chunks = 0